// apps/web/src/lib/csrf-fetch.ts — Fase 01 / Fase 04 (ADR-003, SEC-001).
// Cliente HTTP autenticado por cookie + CSRF double-submit.
// Nenhum token em Web Storage: o CSRF vem de GET /auth/csrf e a sessão
// vive só no cookie HttpOnly.
const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';
export const CSRF_HEADER_NAME = 'x-csrf-token';

interface CsrfResponse {
  readonly csrfToken: string;
}

export async function fetchCsrfToken(): Promise<string> {
  const response = await fetch(`${API_BASE_URL}/api/v1/auth/csrf`, {
    method: 'GET',
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Não foi possível preparar a requisição.');
  }
  const body = (await response.json()) as CsrfResponse;
  return body.csrfToken;
}

/**
 * Falha HTTP de `apiFetch`. É um `Error` comum (mesma mensagem de antes: o corpo da resposta), mas leva o `status`
 * para a tela decidir por ele em vez de procurar números no texto (P3-WR-04).
 */
export class ErroHttpApi extends Error {
  constructor(mensagem: string, readonly status: number) {
    super(mensagem);
    this.name = 'ErroHttpApi';
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
  });
  if (!response.ok) {
    const text = await response.text();
    throw new ErroHttpApi(text || `Erro ${response.status} ao consultar ${path}`, response.status);
  }
  return response.json() as Promise<T>;
}

export async function apiMutate(
  path: string,
  init: { method?: string; body?: unknown; headers?: Record<string, string>; signal?: AbortSignal },
): Promise<Response> {
  const csrfToken = await fetchCsrfToken();
  return fetch(`${API_BASE_URL}${path}`, {
    method: init.method ?? 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      [CSRF_HEADER_NAME]: csrfToken,
      ...init.headers,
    },
    body: init.body === undefined ? undefined : JSON.stringify(init.body),
    signal: init.signal,
  });
}
